import { render, staticRenderFns } from "./productItemMobileView.vue?vue&type=template&id=edb4e6fe&scoped=true&"
import script from "./productItemMobileView.vue?vue&type=script&lang=js&"
export * from "./productItemMobileView.vue?vue&type=script&lang=js&"
import style0 from "./productItemMobileView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./productItemMobileView.vue?vue&type=style&index=1&id=edb4e6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb4e6fe",
  null
  
)

export default component.exports